angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "SEND_OFFER_MODAL": {
    "HOURS": "{HOURS} {HOURS, plural, one{hour} other{hours}}",
    "MESSAGE_MIN_LENGTH" : "Your message is too short. Please be more specific.",
    "REQUIRED" : "This field is required",
    "SEND_OFFERS": {
      "HEADER": "Offer has been sent",
      "BODY": "Thank you! Your offer has been sent successfully. You can expect responses from visitors who are interested. They will appear in your Showaround inbox.",
      "LABEL": "OK, got it",
    },
    "NOT_VERIFIED": {
      "HEADER": "Complete your profile",
      "BODY": "Please complete your profile in order to be able to send offers.",
      "LABEL": "Complete Profile",
    },
    "NOT_ACTIVE": {
      "HEADER": "Activate your status",
      "BODY": "You have previously deactivated your local host status. Activate to be able to send offers.",
      "LABEL": "Activate",
    },
  },
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/components/trips/trips/send_offer_modal/send_offer_modal.json
// module id = 423
// module chunks = 24